var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTfsn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_627_2513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4822 12.1341C12.1129 17.3448 10.0434 24.5811 9.23579 27.04C8.78152 22.4025 11.1791 16.0835 12.9331 12.3507C12.1255 12.3889 7.82248 12.6947 5.4375 15.179C5.4375 15.179 6.72464 11.1913 14.1572 9.98103L14.1824 9.93007C19.9997 1.35603 24.3658 6.47753 24.3658 6.47753C21.7159 6.03163 19.4066 7.36934 17.4381 9.54788C18.3972 9.50966 24.6057 9.43323 26.3975 14.3891C26.3975 14.3891 22.8012 11.7901 15.4822 12.1341ZM19.6842 18.1092C18.1953 18.1092 16.9837 19.3323 16.9837 20.8355C16.9837 22.3388 18.1953 23.5619 19.6842 23.5619C21.1733 23.5619 22.3847 22.3388 22.3847 20.8355C22.3847 19.3195 21.1733 18.1092 19.6842 18.1092Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_627_2513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfsn);
export default __webpack_public_path__ + "static/media/tfsn.1990a7c5428cff1370e458cd77aceca8.svg";
export { ForwardRef as ReactComponent };